// EN
export const listingRatesManager = {
  header: {
    eyebrow: "Tarifs dérivés",
    title: "Tarifs de l'annonce",
    subtitle:
      "Centralisez la configuration de vos tarifs et appliquez-la aux unités de votre choix, même sur plusieurs annonces, sans répéter le travail une par une.",
    newRate: "Nouveau tarif",
  },
  baseInfo: {
    title: "Prix de base par nuit",
    perNight: "/ nuit",
    hint: "Les tarifs dérivés sont calculés comme un ajustement (% ou montant fixe) appliqué à ces prix de base.",
  },
  states: {
    loading: "Chargement des tarifs de l'annonce...",
    emptyTitle: "Aucun tarif dérivé pour le moment",
    emptyText:
      "Créez un tarif dérivé pour synchroniser les prix avec des canaux comme Booking.com ou Airbnb.",
    createFirst: "Créer le premier tarif",
  },
  group: {
    unitsCount: "{count} unité | {count} unités",
    manageTitle: "Gérer le groupe de tarifs",
    manage: "Gérer",
    modalTitle: "Gérer le tarif",
    apply: "Appliquer",
    appliedUnits: "Unités où il est appliqué",
    removeSyncedWarn:
      "Ce tarif est connecté au canal. Le retirer le supprimera également du canal.",
    removeConfirm: "Retirer ce tarif de cette unité ?",
    removing: "Retrait...",
    confirmRemove: "Oui, retirer",
    removeTitle: "Retirer de cette unité",
    remove: "Retirer",
  },
  chips: {
    connect: "Connecter",
    paused: "En pause",
    syncedTitle: "Synchronisé avec le canal",
  },
  actions: {
    editTitle: "Modifier le tarif",
    duplicateTitle: "Dupliquer ou copier",
    pause: "Suspendre les ventes",
    resume: "Reprendre les ventes",
    deleteTitle: "Supprimer",
  },
  modal: {
    createTitle: "Nouveau tarif dérivé",
    editTitle: "Modifier le tarif",
    importPlaceholder: "Copier depuis un tarif existant…",
    namePlaceholder: "Nom du tarif",
    percentage: "% Pourcentage",
    fixed: "Valeur fixe",
    derivationHint: "Une valeur négative diminue le prix de base, une valeur positive l'augmente.",
    searchPlaceholder: "Rechercher…",
    unitsCounter: "{selected} / {total} unités",
    selectAll: "Tout sélectionner",
    deselectAll: "Tout désélectionner",
    loadingUnits: "Chargement…",
    currentBadge: "Actuel",
    unitsWithRate: "{count} unité avec un tarif | {count} unités avec un tarif",
    noBaseRate: "Aucun tarif de base",
    noResults: 'Aucun résultat pour "{query}"',
    create: "Créer le tarif",
    creating: "Création…",
    save: "Enregistrer",
    saving: "Enregistrement…",
  },
  delete: {
    title: "Supprimer le tarif dérivé",
    subtitle: "Confirmez le nom pour éviter de supprimer un tarif par erreur.",
    confirmCopy: "Saisissez le nom du tarif pour confirmer :",
    deleting: "Suppression...",
  },
  types: {
    apartment: "Appartement",
    house: "Maison",
    villa: "Villa",
    hotel: "Hôtel",
    room: "Chambre",
    studio: "Studio",
    camping: "Camping",
    default: "Hébergement",
  },
  misc: {
    noName: "Sans nom",
    unitFallback: "Unité n° {id}",
    basePrefix: "Base :",
  },
  common: {
    cancel: "Annuler",
    delete: "Supprimer",
    close: "Fermer",
  },
  toasts: {
    loadError: "Impossible de charger les tarifs de l'annonce",
    loadListingsError: "Impossible de charger les annonces",
    selectUnit: "Sélectionnez au moins une unité avec un tarif de base.",
    created: "Tarif créé avec succès",
    createdPartial: "Certains tarifs n'ont pas pu être créés",
    createError: "Impossible de créer le tarif",
    updated: "Tarif mis à jour avec succès",
    updateError: "Impossible de mettre à jour le tarif",
    updateErrorGeneric: "Erreur lors de la mise à jour du tarif",
    deleted: "Tarif supprimé",
    deleteError: "Erreur lors de la suppression",
    groupUpdated:
      "Tarif mis à jour dans {count} unité | Tarif mis à jour dans {count} unités",
    groupUpdatedPartial: "{success} mis à jour, {error} en erreur",
    removedFromUnit: "Tarif retiré de cette unité",
    removeError: "Impossible de retirer le tarif",
    removeErrorGeneric: "Erreur lors du retrait du tarif",
    toggleError: "Impossible de changer le statut du tarif",
  },
};
